export function getSourceAccountV3(send) {
  return (sourceAccountId, ...args) =>
    send(
      {
        path: '/v3/sourceAccounts/{sourceAccountId}',
        pathParameters: { sourceAccountId },
        type: 'get',
        query: undefined,
        body: undefined,
        headers: undefined,
        auth: 'oauth2',
        contentType: undefined,
      },
      ...args
    );
}
